'use client'

import { usePathname } from 'next/navigation'
import { useCallback } from 'react'
import {
  addAlert,
  LoadableComponentProps,
  ProductForProductCard,
  ProductGrid as UIProductGrid,
} from 'ui'

import { logger } from '@/helpers/logger'
import { useCart } from '@/store/cartStore'
import { useGlobalTypography } from '@/store/globalTypographyStore'
import { usePreviousPath } from '@/store/previousPathStore'

type ProductGridProps = LoadableComponentProps<{
  products: ProductForProductCard[]
  accessibility?: {
    price?: string
    compareAtPrice?: string
  }
}>

export default function ProductGrid({ data, loading }: ProductGridProps) {
  const cart = useCart()
  const { onChangePrevPath } = usePreviousPath()
  const pathname = usePathname()
  const {
    productPage: { shoppingButtonLabel },
  } = useGlobalTypography()

  const onAddToBasketClick = useCallback(
    async (variantId: string) => {
      try {
        await cart.addToBasket([{ variantId }])
        cart.setIsOpen(true)
      } catch (e) {
        logger.error('ProductGrid > onAddToBasketClick', e)

        addAlert.error('Fehler beim Hinzufügen eines Produkts')
      }
    },
    [cart],
  )

  if (loading) {
    return (
      <>
        <UIProductGrid loading={loading} />
      </>
    )
  }

  const { products, accessibility } = data

  return (
    <UIProductGrid
      data={{
        products: products.map(product => ({
          ...product,
          accessability: { shoppingButtonLabel },
        })),
        accessibility,
        onAddToBasketClick,
        onCardClick: () => onChangePrevPath(pathname),
      }}
    />
  )
}
